<template>
  <div class="save-info-container">
    <img :src="saveInfoBg" alt="">
    <div class="save-info-form">
      <van-field
        v-model="form.userName"
        center
        label="姓名"
        placeholder="请填写您的姓名"
        :disabled="disabled"
      />
      <van-field
        v-model="form.mobile"
        center
        type="tel"
        label="手机号"
        placeholder="请填写您的手机号"
        :disabled="disabled"
      />
      <van-field
        v-model="form.fieldValue"
        center
        is-link
        readonly
        label="地址选择"
        placeholder="请选择所在地区"
        @click="handleShowArea"
      />
      <van-field
        v-model="form.carModel"
        center
        is-link
        readonly
        label="意向车型"
        placeholder="请选择意向车系/车型"
        @click="handleShowCar"
      />
      <van-field
        readonly
        center
        is-link
        label="经销商"
        v-model="form.dealerName"
        placeholder="请选择经销商"
        @click="showDealer"
      />
      <div class="order-btn" @click="handleOrder">
        <img :src="saveInfoBtn" alt="">
      </div>
    </div>
    <van-popup v-model="showCityTree" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="cityTree"
        :field-names="{
          text: 'cityName',
          value: 'cityNumber',
          children: 'children'
        }"
        @close="showCityTree = false"
        @finish="handleCitySelected"
      />
    </van-popup>
    <van-popup v-model="showCarType" round position="bottom">
      <van-cascader
        v-model="cascadercarModel"
        title="请选择意向车型"
        :options="carModel"
        :field-names="{
          text: 'name',
          value: 'id',
          children: 'children'
        }"
        @close="showCarType = false"
        @change="onChange"
        @finish="handleCarTypeSelected"
      />
      <!--@change="onChange"-->
      <!--@finish="handleCarTypeSelected"-->
    </van-popup>
    <van-popup v-model="showDealerList" round position="bottom">
      <van-picker
        show-toolbar
        :columns="filterDealer"
        @cancel="showDealerList = false"
        @confirm="handleDealerSelected"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import {
 sendSms, getCityTree2, getDealerList, getModelTree
} from '@/api'
import { saveRecommendInfo } from '@/api/recommend'
import pca from '@/assets/pca'
import saveInfoBg from '@/assets/images/recommend/save-info-bg.png'
import saveInfoBtn from '@/assets/images/recommend/save-info-btn.png'
import { encryptAES128ECB } from '@/utils/crypto'
// import { initWx } from '@/utils/jssdk'

export default {
  name: 'SaveInfo',
  props: {
    type: {
      type: String,
      default: ''
    },
    activitySource: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveInfoBg,
      saveInfoBtn,
      cityLocation: pca.pca,
      form: {
        userName: null,
        mobile: null,
        sms: null,
        fieldValue: null,
        carModel: null,
        dealerName: null,
        carSeriesCode: null,
        carModelCode: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null
      },
      countDown: false,
      countNumber: 60,
      cascaderValue: null,
      cascadercarModel: null,
      cityTree: [],
      carModel: [],
      brands: [
        {
          name: '皮卡',
          code: 'QK005'
        },
        {
          name: '德沃斯',
          code: 'QK011'
        },
        {
          name: '工程车',
          code: 'QK006'
        },
        {
          name: '骏铃',
          code: 'QK002'
        },
        {
          name: '恺达',
          code: 'QK010'
        },
        {
          name: '康铃',
          code: 'QK001'
        },
        {
          name: '帅铃',
          code: 'QK003'
        }
      ],
      showCityTree: false,
      showCarType: false,
      showDealerList: false,
      showCarList: false,
      columns: [],
      filterDealer: [],
      dealerList: [],
      lat: '',
      lon: '',
      carList: [],
      carModelSelect: null
    }
  },
  methods: {
    handleShowCar() {
      if (!this.disabled) {
        this.showCarType = true
      }
    },
    handleShowArea() {
      if (!this.disabled) {
        this.showCityTree = true
      }
    },
    onChange({ selectedOptions }) {
      this.carModelSelect = selectedOptions
      // console.log(this.carModelSelect)
      // if (tabIndex === 0) {
      //   getSeriesDict({ brandId: value })
      //     .then((res) => {
      //       // eslint-disable-next-line no-param-reassign
      //       selectedOptions[0].children = res.data.map((v) => ({
      //         text: v.name,
      //         value: v.id,
      //         children: []
      //       }))
      //     })
      // }
      // if (tabIndex === 1) {
      //   getModelDict({ brandId: selectedOptions[0].value, seriesId: selectedOptions[1].value })
      //     .then((res) => {
      //       // eslint-disable-next-line no-param-reassign
      //       selectedOptions[1].children = res.data.map((v) => ({
      //         text: v.name,
      //         value: v.id
      //       }))
      //     })
      // }
    },
    sendSMS() {
      const { mobile } = this.form
      if (!this.countDown) {
        if (mobile === '') {
          Toast('请输入手机号')
        } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
          Toast('请输入正确手机号')
        } else {
          const params = {
            sign: 9, // 0-注册或者登录、1-忘记密码、9-通用验证码
            phone: mobile
          }
          this.countDown = true
          sendSms(params)
            .then(() => {
              this.setCountDown()
              Toast('验证码发送成功')
            })
            .catch(() => {
              this.countDown = false
            })
        }
      }
    },
    setCountDown() {
      function sleep(interval) {
        return new Promise((resolve) => {
          setTimeout(resolve, interval)
        })
      }
      (async () => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 60; i++) {
          // eslint-disable-next-line no-plusplus
          this.countNumber--
          // eslint-disable-next-line no-await-in-loop
          await sleep(1000)
        }
        this.countDown = false
        this.countNumber = 60
      })()
    },
    // eslint-disable-next-line consistent-return
    showDealer() {
      if (this.disabled) {
        return ''
      }
      const { carModel, fieldValue } = this.form
      if (!carModel) {
        return Toast('请选择意向车型')
      }
      if (!fieldValue) {
        return Toast('请选择所属区域')
      }
      const car = carModel.split('/')
      const params = {
        pageNum: 1,
        pageSize: 1000,
        modelId: this.cascadercarModel,
        patternId: null
      }
      getDealerList(params, { lat: this.lat, lon: this.lon }).then((res) => {
        const filterDealer = []
        if (res.data.list) {
          this.dealerList = res.data.list
          this.dealerList.forEach((v) => {
            const brand = v.brand.find((item) => item.name === car[0])
            if (brand) {
              filterDealer.push({
                id: v.id,
                name: v.dealerName
              })
            }
          })
          this.filterDealer = filterDealer.map((v) => v.name)
        }
        if (this.filterDealer.length) {
          this.showDealerList = true
        } else {
          Toast('暂无经销商')
        }
      })
    },
    handleCitySelected({ selectedOptions }) {
      this.form.provinceId = selectedOptions[0].cityNumber
      this.form.provinceName = selectedOptions[0].cityName
      this.form.cityId = selectedOptions[1].cityNumber
      this.form.cityName = selectedOptions[1].cityName
      const province = this.cityLocation.find(
        (v) => v.value === this.form.provinceId
      )
      const city = province.children.find((v) => v.value === this.form.cityId)
      this.lat = city.extra.lat
      this.lon = city.extra.lob
      this.showCityTree = false
      this.form.fieldValue = selectedOptions
        .map((option) => option.cityName)
        .join('/')
      this.form.dealerName = null
      this.form.dealer = null
    },
    handleDealerSelected(val) {
      this.form.dealerName = val
      this.form.dealer = this.dealerList.find((v) => v.dealer_name === val)
      this.showDealerList = false
    },
    handleCarTypeSelected({ selectedOptions }) {
      this.showCarType = false
      this.form.carSeriesCode = selectedOptions[0].id
      this.form.carModelCode = selectedOptions[1].id
      this.form.carModel = selectedOptions.map((option) => option.name).join('/')
      this.form.dealerName = null
      this.form.dealer = null
    },
    handleCarSelected(val) {
      this.form.carModel = val
      this.showCarList = false
    },
    // eslint-disable-next-line consistent-return
    handleOrder() {
      const { systemVersion, platform } = this.$route.query
      if (this.disabled) {
        return Toast('此页面只用于分享，快去邀请好友购车吧')
      }
      const {
 userName, mobile, carModel, dealerName, cityId
} = this.form
      if (!userName) {
        return Toast('请输入姓名')
      }
      if (!mobile) {
        return Toast('请输入手机号')
      }
      if (!carModel) {
        return Toast('请选择意向车型')
      }
      if (!cityId) {
        return Toast('请选择所属区域')
      }
      if (!dealerName) {
        return Toast('请选择经销商')
      }
      const dealer = this.dealerList.find((v) => v.dealerName === dealerName)

      const key = '4x9KpLbR2QmN8sY8' // 密钥（需确保为16字节）
      const encryptedData = encryptAES128ECB(
        JSON.stringify({
          cityNumber: cityId,
          dealerNumber: dealer.dealerNumber,
          fromDriverType: this.$route.query.app === 'user' ? 1 : 2,
          fromDriver: this.$route.query.name,
          fromPhone: this.$route.query.phone,
          modelCode: this.carModelSelect[2].id,
          toDriver: userName,
          toPhone: mobile,
          appVersion: systemVersion,
          appSystemType: platform
        }),
        key
      )
      saveRecommendInfo({ code: encryptedData })
        .then(() => {
          Toast('提交成功')
        })
        .catch((err) => Toast(err.message))
    }
    // getLocation() {
    //   // getWxConfig({ url: window.location.href })
    //   getWxConfig({ url: 'http://jacwxmp.starnetah.com:13666/jac-direct-mall-activity-h5/recommend' })
    //     .then((res) => initWx(res.data))
    //     .then(() => {
    //       // eslint-disable-next-line no-undef
    //       wx.ready(() => {
    //         // eslint-disable-next-line no-undef
    //         wx.getLocation({
    //           type: 'wgs84',
    //           success: (res) => {
    //             const { latitude } = res
    //             const { longitude } = res
    //             // const { speed } = res
    //             // const { accuracy } = res
    //             // console.log(latitude, longitude)
    //             this.lat = latitude
    //             this.lon = longitude
    //           }
    //         })
    //       })
    //     })
    // }
  },
  mounted() {
    // this.getLocation()
  },
  created() {
    // alert(window.location.href.split('#')[0])
    getCityTree2()
      .then((res) => {
        this.cityTree = res.data
      })
      .catch((err) => console.log(err.message))
    // getBrandDict()
    //   .then((res) => {
    //     this.carModel = res.data.map((v) => ({
    //       text: v.name,
    //       value: v.id,
    //       children: []
    //     }))
    //   })

    getModelTree().then((res) => {
      this.carModel = res.data
    })
  }
}
</script>

<style scoped lang="scss">
.save-info-container {
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  .save-info-form {
    position: absolute;
    top: rem(113);
    background-color: transparent;
    width: 100%;
    padding-left: rem(56);
    padding-right: rem(56);
    box-sizing: border-box;
    .van-cell::after {
      right: 0;
      left: 0;
    }
    .van-cell {
      padding-left: rem(22);
      padding-right: 0;
      height: rem(96);
      margin-bottom: rem(24);
      border-style: solid;
      border-width: 1px;
      border-color: rgb(245, 222, 180);
      border-radius: rem(12);
      background-color: rgb(255, 249, 232);
      &:last-child::after {
        display: block;
      }
      ::v-deep {
        .van-icon-arrow {
          display: none;
        }
        .van-cell__title,
        .van-cell__value {
          line-height: 32.125px;
        }
        .van-field__label {
          font-size: rem(30);
          color: #ca9a58;
          width: rem(150);
        }
        input,
        textarea {
          color: #ca9a58;
          font-size: rem(30);
        }
        input::placeholder,
        textarea::placeholder {
          color: #bdbdbd;
        }
      }
      .sendSMS.van-button--primary {
        background-color: transparent;
        border: none;
        color: #333333;
      }
    }
    .order-btn {
      margin-top: rem(49);
      height: rem(96);
      border-radius: 10px;
      background-image: -moz-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      background-image: -webkit-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      background-image: -ms-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      box-shadow: 0px 6px 0px 0px rgba(218, 176, 7, 0.004);
      background-color: #ffffff;
      color: #9f0e12;
      font-size: rem(32);
      text-align: center;
      line-height: rem(96);
    }
  }
}
</style>
